<canvas id="canvasProductivity2" class="canvasProductivity canvasProductivity2" width="183" height="183"></canvas>
